import React from 'react';
import {
  defaultProps,
  DefaultProps,
  Props,
} from 'interfaces/Input';
import { translate } from '../../utils/utils';
import Labels from '../../enums/Labels';
import { TafChangeEvent } from '@taf-ui/core';
import { TafTextInput } from '@taf-ui/react';
import AppStorage from '../../Storage/Storage';

/*
 TODO: Convert to function component once
 https://github.com/microsoft/TypeScript/issues/27425 and https://github.com/microsoft/TypeScript/issues/31247
 are fixed.
*/
class InputText extends React.PureComponent<Props> {
  static defaultProps: DefaultProps = defaultProps;

  private readonly storage: AppStorage;

  constructor(props: Props) {
    super(props);
    this.storage = AppStorage.getInstance();
  }

  handleChange = (e: CustomEvent<TafChangeEvent<string>>) => {
    const {
      input,
      onBlurHandler,
      onChangeHandler,
    } = this.props;
    if (e.detail.value !== undefined) {
      input.onChange(e.detail.value);
      if (onChangeHandler) {
        onChangeHandler(e);
      }
      if (onBlurHandler) {
        /* TODO we need proper solution, I added fix for Safari users, we will do the delay 100ms,
            in this time TafQuestionnaireText will update state "isChange" and storeCurrentValueHandler will be triggered
         */
        setTimeout(() => onBlurHandler(e), 100);
      }
    }
  };

  render(): React.ReactElement {
    const {
      input,
      meta,
      isRequired,
      label,
      inputWrapperClass,
      disabled,
    } = this.props;
    const lang = this.storage.getLocale;

    return (
      <div className={inputWrapperClass}>
        <TafTextInput
          label={translate(label as Labels, lang)}
          required={isRequired}
          value={input.value}
          name={input.name}
          inputId={input.name}
          onTafChange={this.handleChange}
          onTafBlur={() => input.onBlur()}
          validationState={meta.error && meta.touched ? 'error' : undefined}
          validationMessage={translate(meta.error as Labels, lang)}
          disabled={disabled}
        />
      </div>
    );
  }
}

InputText.defaultProps = defaultProps;

export default InputText;
